export interface ShippoCardProps {}

export enum ShippoSettingsModalType {
  GeneralSettings = 'General Settings',
  InternationalSettings = 'International Settings',
  ShippingExtrasSettings = 'Shipping Extras',
}
